import React from 'react';

// Updated type to match Backend expectations
export type ColumnKeys =
  | 'file_name'
  | 'file_content_type'
  | 'file_size'
  | 'created_at'
  | 'updated_at'
  | 's3_location';

interface IUploadColumnsProps {
  sortData: (key: ColumnKeys) => void;
  sortConfig: { key: ColumnKeys; direction: string };
  isSelectedItems?: boolean;
  handleCheckboxClick?: () => void;
}

const UploadColumns: React.FC<IUploadColumnsProps> = ({
  sortData,
  sortConfig,
  isSelectedItems,
  handleCheckboxClick,
}) => {
  const getSortIcon = (key: ColumnKeys) => {
    if (sortConfig.key !== key) {
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
        >
          <path
            d='M8 4V12M8 4L4 8M8 4L12 8'
            stroke='var(--text-classify)'
            strokeOpacity='0.5'
            strokeWidth='1.33'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    }

    if (sortConfig.direction === 'asc') {
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
        >
          <path
            d='M8 12.6666V3.33331M8 3.33331L3.33333 7.99998M8 3.33331L12.6667 7.99998'
            stroke='var(--text-classify)'
            strokeWidth='1.33'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    }

    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
      >
        <path
          d='M8 3.33331V12.6666M8 12.6666L3.33333 7.99998M8 12.6666L12.6667 7.99998'
          stroke='var(--text-classify)'
          strokeWidth='1.33'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    );
  };

  const CheckboxIcon = () =>
    isSelectedItems ? (
      <div className='full-list-filters-cont-row-icon-item'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='12'
          height='12'
          viewBox='0 0 12 12'
          fill='none'
        >
          <path
            d='M10 3L4.5 8.5L2 6'
            stroke='var(--text-primary)'
            strokeWidth='1.6666'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </div>
    ) : (
      <div className='full-list-filters-cont-row-icon-item-unselected'></div>
    );

  return (
    <div className='screening-results-columns'>
      <div
        className='screening-table-placeholder-column'
        style={{ borderTopLeftRadius: 'var(--radius-xl, 12px)', width: '48px' }}
      >
        <div
          className='screening-results-row-default-cell-inner'
          onClick={handleCheckboxClick}
        >
          <CheckboxIcon />
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div
            className='screening-table-column-text'
            onClick={() => sortData('file_name')}
          >
            File Name {getSortIcon('file_name')}
          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div
          className='screening-table-title-column-inner'
          onClick={() => sortData('file_content_type')}
        >
          <div className='screening-table-column-text'>
            File Type {getSortIcon('file_content_type')}
          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div
          className='screening-table-title-column-inner'
          onClick={() => sortData('file_size')}
        >
          <div className='screening-table-column-text'>
            Size {getSortIcon('file_size')}
          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div
          className='screening-table-title-column-inner'
          onClick={() => sortData('created_at')}
        >
          <div className='screening-table-column-text'>
            Created {getSortIcon('created_at')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadColumns;
